export function objectMap(object, mapFunction) {
    return Object.fromEntries(
        Object.entries(object).map(
            ([key, value], index) => [key, mapFunction(value, key, index)]
        )
    );
}

export function reloadScreen() {
    window.location.reload(false);
}